import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import Header from "@/components/sections/Header";
import Footer from "@/components/sections/Footer";
import { useSeo } from "@/lib/useSeo";

/**
 * Content hub: "Rady pro správu a úklid firemních prostor"
 *
 * Topical-authority engine. Future articles are added by:
 *  1. Creating a new page that wraps content in <ArticleLayout />
 *  2. Adding a route in App.js for the article URL
 *  3. Appending an entry to the ARTICLES array below with published: true
 *
 * Drafts (published: false) appear as "Připravujeme" cards — unclickable.
 */

export const ARTICLES = [
  {
    slug: "/kolik-stoji-uklid-kancelari-brno",
    title: "Kolik stojí úklid kanceláří v Brně?",
    excerpt:
      "Co ovlivňuje cenu úklidu kanceláří v Brně, modelové příklady kalkulace a orientační ceník.",
    published: true,
  },
  {
    slug: "/co-zahrnuje-pravidelny-uklid-kancelari",
    title: "Co zahrnuje pravidelný úklid kanceláří?",
    excerpt:
      "Detailní rozpis služby — pracovní stoly, podlahy, kuchyňka, WC, prosklení. Denní, týdenní a měsíční úkoly. Co je v paušálu a co zvlášť.",
    published: true,
  },
  {
    slug: "/jak-casto-uklizet-kancelare",
    title: "Jak často uklízet kanceláře a administrativní budovy?",
    excerpt:
      "Doporučená frekvence úklidu pro malé, středně velké i velké administrativní prostory. Denní, týdenní a měsíční úkoly.",
    published: true,
  },
  {
    slug: "/uklid-administrativnich-budov",
    title: "Úklid administrativních budov v Brně: co zahrnuje a jak probíhá?",
    excerpt:
      "Co řešit u vícepatrových administrativních objektů — denní, týdenní a měsíční úkoly, recepce, výtahy, hygienické standardy a frekvence úklidu.",
    published: true,
  },
  {
    slug: "/jak-vybrat-uklidovou-firmu",
    title: "Jak vybrat úklidovou firmu pro kancelář v Brně?",
    excerpt:
      "Praktický průvodce — 7 kritérií, varovné signály, otázky před podpisem smlouvy a srovnání úklidová firma vs. živnostník.",
    published: true,
  },
  {
    slug: "/outsourcing-uklidu-vs-vlastni-zamestnanec",
    title: "Outsourcing úklidu vs. vlastní zaměstnanec: co se firmám více vyplatí?",
    excerpt:
      "Srovnání nákladů, flexibility, kvality a rizik. Kdy se externí úklidová firma vyplatí víc než vlastní uklízečka.",
    published: true,
  },
  {
    slug: "/kolik-stoji-uklid-administrativni-budovy-brno",
    title: "Kolik stojí úklid administrativní budovy v Brně?",
    excerpt:
      "Cenová kalkulace úklidu administrativní budovy v Brně podle velikosti, modelové příklady, společné prostory a chyby při výběru dodavatele.",
    published: true,
  },
  {
    slug: "/jak-prevzit-uklid-od-jine-uklidove-firmy",
    title: "Jak převzít úklid od jiné úklidové firmy bez problémů?",
    excerpt:
      "Změna úklidové firmy bez výpadku kvality — 7krokový proces převzetí, předávací protokol, nejčastější chyby a tipy z praxe.",
    published: true,
  },
  {
    slug: "/nejcastejsi-chyby-spravcu-budov-pri-zajisteni-uklidu",
    title: "Nejčastější chyby správců budov při zajištění úklidu",
    excerpt:
      "10 typických chyb facility managementu při řízení úklidu administrativních budov a praktický checklist pro správce.",
    published: true,
  },
  {
    slug: "/vyberove-rizeni-na-uklid-kancelari",
    title: "Jak probíhá výběrové řízení na úklid kanceláří a administrativních budov?",
    excerpt:
      "Strukturovaný postup tendru — zadávací dokumentace, hodnotící kritéria, prohlídka, ústní obhajoba, smlouva a pilotní fáze. Checklist pro správce budovy.",
    published: true,
  },
  {
    slug: "/uklid-kancelari-po-rekonstrukci",
    title: "Úklid kanceláří po rekonstrukci: na co si dát pozor?",
    excerpt:
      "Stavební prach, kontaminanty, čtyřstupňový proces úklidu po stavebních pracích a nejčastější chyby firem. Kdy povolat profesionální firmu a kolik to stojí.",
    published: true,
  },
  {
    slug: "/jak-poznat-kvalitni-uklidovou-firmu-brno",
    title: "Jak poznat kvalitní úklidovou firmu v Brně?",
    excerpt:
      "Praktický přehled kritérií — reference, kontrola kvality, pojištění, komunikace a cena. Varovné signály a checklist před podpisem smlouvy.",
    published: true,
  },
  {
    slug: "/kontrola-kvality-uklidu-kancelari",
    title: "Jak kontrolovat kvalitu úklidu kanceláří?",
    excerpt:
      "Checklist, audit, reporting, KPI a SLA — kompletní průvodce, jak správci budov a facility manageři efektivně hodnotí kvalitu úklidu kanceláří.",
    published: true,
  },
  {
    slug: "/rady-pro-spravu-uklidu/kolik-stoji-uklid-bytoveho-domu-brno",
    title: "Kolik stojí úklid bytového domu v Brně?",
    excerpt:
      "Orientační ceny podle velikosti domu, co ovlivňuje kalkulaci a modelové příklady pro SVJ v Brně.",
    published: true,
  },
  {
    slug: "/rady-pro-spravu-uklidu/co-zahrnuje-uklid-spolecnych-prostor-bytoveho-domu",
    title: "Co zahrnuje úklid společných prostor bytového domu?",
    excerpt:
      "Detailní rozpis — schodiště, výtah, vchod, suterén, okolí. Co je v paušálu a co se hradí zvlášť.",
    published: true,
  },
  {
    slug: "/rady-pro-spravu-uklidu/jak-vybrat-uklidovou-firmu-pro-bytovy-dum",
    title: "Jak vybrat úklidovou firmu pro bytový dům?",
    excerpt:
      "6 kritérií pro SVJ a správce budov — reference, smlouva, pojištění, zastupitelnost a varovné signály.",
    published: true,
  },
  {
    slug: "/rady-pro-spravu-uklidu/jak-casto-uklidet-spolecne-prostory-bytoveho-domu",
    title: "Jak často uklízet společné prostory bytového domu?",
    excerpt:
      "Doporučená frekvence úklidu schodiště, výtahu, vchodu a okolí pro SVJ v Brně — přehledná tabulka a praktické rady.",
    published: true,
  },
];

const Rady = () => {
  useSeo({
    title:
      "Rady pro správu a úklid firemních prostor | SANVIORO Brno",
    description:
      "Praktické rady a doporučení pro úklid kanceláří, firemních prostor a administrativních budov v Brně. Cenotvorba, frekvence úklidu, výběr dodavatele.",
    path: "/rady-pro-spravu-uklidu",
  });

  const ldJson = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "Rady pro správu a úklid firemních prostor",
    description:
      "Praktické rady, doporučení a informace pro firmy, správce budov, administrativní centra a provozovny v Brně.",
    url: "https://sanvioro.cz/rady-pro-spravu-uklidu",
    inLanguage: "cs-CZ",
    isPartOf: {
      "@type": "WebSite",
      name: "SANVIORO",
      url: "https://sanvioro.cz/",
    },
  };

  return (
    <div
      className="App font-body text-[#111111] bg-white"
      data-testid="rady-hub-page"
    >
      <Header />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(ldJson) }}
      />

      {/* HERO */}
      <section className="bg-[#F5F5F7] pt-32 md:pt-40 pb-16 md:pb-20 border-b border-[#E5E5E5]">
        <div className="mx-auto max-w-[1100px] px-6 md:px-12">
          <div className="text-xs uppercase tracking-[0.28em] font-bold text-[#0F5C69]">
            Content hub · Brno
          </div>
          <h1
            data-testid="page-h1"
            className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl font-bold tracking-[-0.025em] leading-[1.05] max-w-3xl text-[#111111]"
          >
            Rady pro správu a úklid firemních prostor.
          </h1>
          <p className="mt-8 max-w-2xl text-[#444444] leading-relaxed text-base md:text-lg">
            Praktické rady, doporučení a informace pro firmy, správce budov,
            administrativní centra a provozovny v Brně.
          </p>
        </div>
      </section>

      {/* ARTICLE GRID */}
      <section className="bg-white py-16 md:py-20">
        <div className="mx-auto max-w-[1100px] px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {ARTICLES.map((a) => {
              const card = (
                <>
                  <div className="flex items-center gap-2 text-[#0F5C69]">
                    <BookOpen size={16} strokeWidth={2} />
                    <span className="text-[11px] uppercase tracking-[0.2em] font-bold">
                      {a.published ? "Článek" : "Připravujeme"}
                    </span>
                  </div>
                  <h2 className="mt-4 font-display text-xl md:text-2xl font-bold tracking-tight leading-tight text-[#111111] group-hover:text-[#0F5C69] transition-colors">
                    {a.title}
                  </h2>
                  <p className="mt-3 text-[15px] text-[#555555] leading-relaxed">
                    {a.excerpt}
                  </p>
                  {a.published && (
                    <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[#0F5C69]">
                      Číst článek
                      <ArrowRight
                        size={14}
                        strokeWidth={2.5}
                        className="transition-transform group-hover:translate-x-1"
                      />
                    </span>
                  )}
                </>
              );
              return a.published ? (
                <Link
                  key={a.slug}
                  to={a.slug}
                  data-testid={`article-card-${a.slug}`}
                  className="group block bg-white border border-[#E5E5E5] rounded-2xl p-7 md:p-8 hover:border-[#0F5C69] transition-colors"
                >
                  {card}
                </Link>
              ) : (
                <div
                  key={a.slug}
                  data-testid={`article-card-${a.slug}`}
                  className="group bg-white border border-[#E5E5E5] rounded-2xl p-7 md:p-8 opacity-80"
                >
                  {card}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA back to services */}
      <section className="bg-[#F5F5F7] py-12 md:py-16 border-t border-[#E5E5E5]">
        <div className="mx-auto max-w-[1100px] px-6 md:px-12 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div>
            <h2 className="font-display text-2xl md:text-3xl font-bold tracking-tight text-[#111111]">
              Hledáte konkrétní službu?
            </h2>
            <p className="mt-2 text-[#555555]">
              Naše hlavní služby pro firmy a SVJ v Brně.
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/uklid-kancelari-brno"
              className="inline-flex items-center gap-2 bg-[#0F5C69] text-white px-5 h-11 font-semibold tracking-tight hover:bg-[#0B4B55] transition-colors"
            >
              Úklid kanceláří v Brně
            </Link>
            <Link
              to="/uklid-provozoven-brno"
              className="inline-flex items-center gap-2 border border-[#0F5C69]/30 text-[#0F5C69] px-5 h-11 font-semibold tracking-tight hover:bg-[#E6F2F4] transition-colors"
            >
              Úklid provozoven
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Rady;
